/// <amd-module name="Wiki/DeletePageDialog/DeletePageDialog" />
import * as React from "react";

import * as Utils_String from "VSS/Core/Util/String";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Dialog } from "VSSUI/Dialog";

import { IGlobalMessagesService } from "TFS/GlobalBanner/GlobalMessagesService";

import { GitVersionDescriptor } from "Wiki/Clients/VC/Contracts/Git";
import { WikiPage, WikiPageResponse, WikiV2 } from "Wiki/Clients/Wiki/Contracts/Wiki";
import { getWikiClient } from "Wiki/Clients/Wiki/RestClient/Wiki";
import * as Resources from "Wiki/DeletePageDialog/Resources";
import { TelemetryConstants } from "Wiki/ViewCommon/CustomerIntelligenceConstants";
import { getFileName, isInclude } from "Wiki/ViewCommon/Utils/PathHelper";
import { publish } from "Wiki/ViewCommon/Utils/WikiHelper";

export interface DeletePageDialogProps {
    onDismiss: () => void;
    page: WikiPage;
    wiki: WikiV2;
    version: GitVersionDescriptor;
    onPageDelete: (pagePath: string) => void;
}

export interface DeletePageDialogState {
    isDeleteInProgress?: boolean;
}

export class DeletePageDialog extends VssComponent<DeletePageDialogProps, DeletePageDialogState> {
    constructor(props: DeletePageDialogProps, context: IVssComponentContext) {
        super(props, context);

        this.state = {};
    }

    public render(): JSX.Element {
        const { onDismiss } = this.props;
        const title = getFileName(this.props.page.path);
        const deleteButtonClassName = "delete-wiki-page-cancel-button";
        return (
            <Dialog
                onDismiss={onDismiss}
                titleProps={{ text: Utils_String.format(Resources.DeletePageDialogTitleText, title) }}
                footerButtonProps={[
                    {
                        text: Resources.DeletePageDialogCancelButtonText,
                        onClick: this._onDeleteDialogCancel,
                        className: deleteButtonClassName
                    },
                    {
                        text: Resources.DeletePageDialogButtonText,
                        danger: true,
                        disabled: this.state.isDeleteInProgress,
                        onClick: this._onDelete
                    }
                ]}
                defaultActiveElement={"." + deleteButtonClassName}
            >
                <span className="delete-dialog-message">{Utils_String.format(Resources.DeletePageDialogInfoText, title)}</span>
            </Dialog>
        );
    }

    private _onDelete = (): void => {
        const pagePath = this.props.page.path;
        this.setState({ isDeleteInProgress: true });
        this.trackPromise(
            getWikiClient(this.context.pageContext).deletePage(this.props.wiki.projectId, this.props.wiki.id, pagePath, undefined, this.props.version)
        ).promise.then(
            (pageResponse: WikiPageResponse) => {
                publish(this.context.pageContext, TelemetryConstants.PageDeleted, this.props.wiki.type, { IsIncludePage: isInclude(pagePath) });
                this.setState({ isDeleteInProgress: false });
                this.props.onDismiss();
                this.props.onPageDelete(pagePath);
            },
            (error: Error) => {
                this.setState({ isDeleteInProgress: false });
                if (!(error instanceof Error) || error.name !== "RequestNoLongerValid") {
                    const messagesService = this.context.pageContext.getService<IGlobalMessagesService>("IGlobalMessagesService");

                    messagesService.addToast({
                        message: error.message,
                        duration: 5000,
                        forceOverrideExisting: true
                    });
                }
            }
        );
    };

    private _onDeleteDialogCancel = () => {
        publish(this.context.pageContext, TelemetryConstants.DeletePageDialogDismissed, this.props.wiki.type);
        this.props.onDismiss();
    };
}

VssComponent.register("Wiki.DeletePageDialog", DeletePageDialog);
